import React from "react";
import { useDispatch } from "react-redux";
import { FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Select, { components } from "react-select";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";


export default function ApprovalModal(props) {

  const {
    size = 'md',
    isOpen = false,
    setIsOpen,
    reasonItems = [],
    onClickApprove,
    selectedReason,
    setSelectedReason,
    disabled,
    loading,
  } = props;

  const dispatch = useDispatch();

  const closeDialog = () => {
    setIsOpen(false);
  }

  return (
    <div className="flex flex-col modal-lg">
      <Modal size={size} isOpen={isOpen} toggle={() => closeDialog()}>
        <ModalHeader toggle={() => {
          closeDialog()
        }}>
          Discount Approval
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="currency">Reason</Label>
            <Select
              className="select2-filter"
              placeholder="Select Reason"
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={(reasonItems || []).find((item) => item.id === selectedReason) || null}
              onChange={(e) => {
                setSelectedReason(e ? e.id : null);
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              isClearable={true}
              options={reasonItems || []}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter className="mt-2">
          <button
            className="btn btn-secondary mr-2"
            onClick={() => closeDialog()}
            disabled={disabled}
          >
            Close
          </button>
          <ButtonLoader
            color="primary" btntext="Approve"
            onClick={() => onClickApprove()}
            disabled={disabled} loading={loading} />
        </ModalFooter>
      </Modal>
    </div>
  )
}